<template>
    <div>
        <NavBar></NavBar>
        <div class="row">
            <MarketWatch class="col-md-4 d-none d-md-block"></MarketWatch>
            <div class="col-md-8 d-flex align-items-center justify-content-center vh-100" v-if="$store.state.positions.length == 0">
                <div class="empty-state">
                    <div class="empty-icon">
                        <i class="bi bi-credit-card-2-front"></i>
                    </div>
                    <h5>No Positions Yet</h5>
                    <p>Your open positions will appear here</p>
                </div>
            </div>
            <div class="col-md-8" v-else>
                <div class="page-container">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div class="header-left">
                            <h4 class="page-title">
                                <i class="bi bi-credit-card-2-front"></i>
                                Positions
                            </h4>
                            <span class="item-count">{{ $store.state.positions.length }} items</span>
                        </div>
                        <div class="total-pl-badge" :class="plPositive ? 'positive' : 'negative'">
                            <span class="pl-label">Total P&L</span>
                            <span class="pl-amount">{{ getTotalPl() }}</span>
                        </div>
                    </div>

                    <!-- Desktop Table -->
                    <div class="data-table d-none d-md-block">
                        <div class="table-header">
                            <div class="col-check"><input class="form-check-input" type="checkbox" v-model="checkAllFlag" @change="checkAll()"></div>
                            <div class="col-product">Product</div>
                            <div class="col-instrument">Instrument</div>
                            <div class="col-qty">Qty</div>
                            <div class="col-avg">Avg</div>
                            <div class="col-ltp">LTP</div>
                            <div class="col-pl">P&L</div>
                            <div class="col-chg">Chg</div>
                            <div class="col-action"></div>
                        </div>
                        <div class="table-row" v-for="(item, index) in $store.state.positions" :key="index" :class="{'faded': item.qty == 0}">
                            <div class="col-check"><input class="form-check-input" type="checkbox" v-model="item.check" @change="exitButton()"></div>
                            <div class="col-product"><span class="product-badge">{{ item.duration }}</span></div>
                            <div class="col-instrument"><span class="instrument-name">{{ item.instrumentName }}</span></div>
                            <div class="col-qty">{{ item.qty }}</div>
                            <div class="col-avg">{{ item.priceAvg.toFixed(2) }}</div>
                            <div class="col-ltp">{{ $store.state.ticker[item.instrumentToken] }}</div>
                            <div class="col-pl" :class="item.plColor ? 'positive' : 'negative'">{{ getPlSign(item) }}</div>
                            <div class="col-chg">{{ getPercentageChange(item.priceAvg, $store.state.ticker[item.instrumentToken]) }}</div>
                            <div class="col-action">
                                <div class="action-btns" v-if="item.qty != 0">
                                    <button class="btn-action exit" @click="exit(index)" title="Exit">
                                        <i class="bi bi-dash-circle"></i>
                                    </button>
                                    <button class="btn-action add" @click="add(index)" title="Add">
                                        <i class="bi bi-plus-circle"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-footer" v-if="exitButtonVisible">
                            <button type="button" class="btn-exit-all" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                <i class="bi bi-box-arrow-right"></i>
                                Exit {{ exitButtonCount }} position(s)
                            </button>
                        </div>
                    </div>

                    <!-- Mobile Cards -->
                    <div class="d-block d-md-none mobile-container">
                        <div class="position-card" v-for="(item, index) in $store.state.positions" :key="index" :class="{'faded': item.qty == 0}">
                            <div class="card-header-row">
                                <div class="header-left">
                                    <span class="instrument-name">{{ item.instrumentName }}</span>
                                    <span class="product-badge">{{ item.duration }}</span>
                                </div>
                                <input class="form-check-input" type="checkbox" v-model="item.check" @change="exitButton()">
                            </div>
                            <div class="card-details">
                                <div class="detail-item">
                                    <span class="detail-label">Qty</span>
                                    <span class="detail-value">{{ item.qty }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">Avg</span>
                                    <span class="detail-value">{{ item.priceAvg.toFixed(2) }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">LTP</span>
                                    <span class="detail-value">{{ $store.state.ticker[item.instrumentToken] }}</span>
                                </div>
                                <div class="detail-item">
                                    <span class="detail-label">P&L</span>
                                    <span class="detail-value" :class="item.plColor ? 'positive' : 'negative'">{{ getPlSign(item) }}</span>
                                </div>
                            </div>
                            <div class="card-footer-row">
                                <span class="change-badge" :class="item.plColor ? 'positive' : 'negative'">
                                    {{ getPercentageChange(item.priceAvg, $store.state.ticker[item.instrumentToken]) }}
                                </span>
                                <div class="card-actions" v-if="item.qty != 0">
                                    <button class="btn-card exit" @click="exit(index)">Exit</button>
                                    <button class="btn-card add" @click="add(index)">Add</button>
                                </div>
                            </div>
                        </div>
                        <button type="button" v-if="exitButtonVisible" class="btn-exit-mobile" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <i class="bi bi-box-arrow-right"></i>
                            Exit {{ exitButtonCount }} position(s)
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Exit Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Exit {{ exitButtonCount }} Position(s)</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p class="modal-subtitle">The following positions will be closed at market price:</p>
                        <div class="exit-list">
                            <div class="exit-item" v-for="(item, index) in $store.state.positions" :key="index" v-if="item.check">
                                <i class="bi bi-arrow-right-circle"></i>
                                <span>{{ item.instrumentName }}</span>
                                <span class="mkt-badge">MKT</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="placeOrders()">Confirm Exit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/main/NavBar.vue'
import MarketWatch from '@/components/marketwatch/MarketWatch'
import { getPositions, buysellBulk } from '@/service/restService'
import '@/service/utils.js'
export default {
  name: 'Position',
  components: {
    NavBar,
    MarketWatch
  },
  data () {
    return {
      plPositive: false,
      checkAllFlag: false,
      exitButtonVisible: false,
      exitButtonCount: 0
    }
  },
  methods: {
    getPositions: function () {
      getPositions().then((response) => {
        this.$store.commit('updatePosition', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    getPlSign: function (item) {
      var res = this.getPl(item)
      item.plColor = res >= 0
      return res > 0 ? '+' + res : '' + res
    },
    getPl: function (item) {
      if (item.type === 'LONG') {
        return (item.pl + (this.$store.state.ticker[item.instrumentToken] - item.priceAvg) * item.qty).toFixed(2)
      } else if (item.type === 'SHORT') {
        return (item.pl + (item.priceAvg - this.$store.state.ticker[item.instrumentToken]) * item.qty * -1).toFixed(2)
      } else {
        return (item.pl).toFixed(2)
      }
    },
    getTotalPl: function () {
      var totalPL = 0.0
      for (var i = 0; i < this.$store.state.positions.length; i++) {
        var pos = this.$store.state.positions[i]
        var pl = this.getPl(pos)
        totalPL = totalPL + parseFloat(pl)
      }
      this.plPositive = totalPL >= 0
      return totalPL > 0 ? '+' + totalPL.toFixed(2) : '' + totalPL.toFixed(2)
    },
    checkAll: function () {
      for (var i = 0; i < this.$store.state.positions.length; i++) {
        var pos = this.$store.state.positions[i]
        pos.check = this.checkAllFlag
      }
      this.exitButton()
    },
    exitButton: function () {
      var exitButtonFlag = false
      this.exitButtonCount = 0
      for (var i = 0; i < this.$store.state.positions.length; i++) {
        var pos = this.$store.state.positions[i]
        if (pos.check && pos.qty === 0) {
          pos.check = false
        }
        if (pos.check) {
          exitButtonFlag = true
          this.exitButtonCount = this.exitButtonCount + 1
        }
      }
      if (!exitButtonFlag) {
        this.checkAllFlag = false
      }
      this.exitButtonVisible = exitButtonFlag
    },
    exit: function (id) {
      var pos = this.$store.state.positions[id]
      var type = pos.qty > 0 ? 'SELL' : 'BUY'
      var mw = { }
      mw.instrumentToken = pos.instrumentToken
      mw.displayName = pos.instrumentName
      mw.qty = Math.abs(pos.qty)
      mw.duration = pos.duration
      mw.lotSize = pos.lotSize
      this.$store.commit('setBuySell', {'type': type, 'mw': mw})
    },
    add: function (id) {
      var pos = this.$store.state.positions[id]
      var type = pos.qty > 0 ? 'BUY' : 'SELL'
      var mw = { }
      mw.instrumentToken = pos.instrumentToken
      mw.displayName = pos.instrumentName
      mw.qty = Math.abs(pos.qty)
      mw.duration = pos.duration
      mw.lotSize = pos.lotSize
      this.$store.commit('setBuySell', {'type': type, 'mw': mw})
    },
    placeOrders: function () {
      var buySellObjectArr = []
      for (var i = 0; i < this.$store.state.positions.length; i++) {
        var pos = this.$store.state.positions[i]
        if (pos.check && pos.qty !== 0) {
          var buySellObject = {
            'instrumentToken': pos.instrumentToken,
            'qty': Math.abs(pos.qty),
            'type': (pos.qty > 0) ? 'SELL' : 'BUY',
            'duration': pos.duration,
            'price': 0,
            'triggerPrice': 0,
            'orderType': 'MKT'
          }
          buySellObjectArr.push(buySellObject)
        }
      }
      buysellBulk(buySellObjectArr).then((response) => {
        this.exitButtonVisible = false
        for (var i = 0; i < response.data.length; i++) {
          var res = response.data[0]
          if (res.status === 'COMPLETE') {
            this.$store.commit('addExecutedOrder', res)
            this.$store.commit('addToast', {
              title: 'Success!',
              type: 'success',
              message: 'Order executed Successfully for ' + res.instrumentName
            })
          }
          if (res.status === 'FAILED') {
            this.$store.commit('addToast', {
              title: 'Failure!',
              type: 'error',
              message: res.msg
            })
          }
        }
        this.getPositions()
        this.getUserView()
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    }

  },
  created () {
    if (this.$store.state.positionFirstTimeFlag) {
      this.getPositions()
      this.$store.commit('disablePositionFirstTime')
    }
    this.exitButton()
  }
}
</script>

<style scoped>
/* Page Container */
.page-container {
  padding: 20px;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--bs-tertiary-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.empty-icon i {
  font-size: 36px;
  color: var(--bs-secondary-color);
}

.empty-state h5 {
  color: var(--bs-body-color);
  margin-bottom: 8px;
}

.empty-state p {
  color: var(--bs-secondary-color);
  margin: 0;
}

/* Page Header */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-weight: 600;
  color: var(--bs-body-color);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
}

.page-title i {
  color: var(--bs-primary);
}

.item-count {
  background: var(--bs-tertiary-bg);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  color: var(--bs-secondary-color);
}

.total-pl-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 16px;
  border-radius: 10px;
  background: var(--bs-tertiary-bg);
}

.total-pl-badge.positive {
  background: rgba(11, 218, 81, 0.1);
}

.total-pl-badge.negative {
  background: rgba(239, 1, 7, 0.1);
}

.total-pl-badge .pl-label {
  font-size: 11px;
  color: var(--bs-secondary-color);
}

.total-pl-badge .pl-amount {
  font-size: 18px;
  font-weight: 700;
}

.total-pl-badge.positive .pl-amount {
  color: #0BDA51;
}

.total-pl-badge.negative .pl-amount {
  color: #EF0107;
}

/* Desktop Table */
.data-table {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: grid;
  grid-template-columns: 40px 70px 2fr 60px 80px 80px 100px 70px 80px;
  padding: 12px 16px;
  background: var(--bs-tertiary-bg);
  font-size: 12px;
  font-weight: 600;
  color: var(--bs-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  align-items: center;
}

.table-row {
  display: grid;
  grid-template-columns: 40px 70px 2fr 60px 80px 80px 100px 70px 80px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--bs-border-color);
  align-items: center;
  transition: background-color 0.2s;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background: var(--bs-tertiary-bg);
}

.table-row.faded {
  opacity: 0.5;
}

.table-row .instrument-name {
  font-weight: 600;
  color: var(--bs-body-color);
}

.product-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  background: var(--bs-tertiary-bg);
  color: var(--bs-secondary-color);
}

.table-row .positive {
  color: #0BDA51;
  font-weight: 600;
}

.table-row .negative {
  color: #EF0107;
  font-weight: 600;
}

.action-btns {
  display: flex;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s;
}

.table-row:hover .action-btns {
  opacity: 1;
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-action.exit {
  background: rgba(239, 1, 7, 0.1);
  color: #EF0107;
}

.btn-action.exit:hover {
  background: #EF0107;
  color: white;
}

.btn-action.add {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.btn-action.add:hover {
  background: #0d6efd;
  color: white;
}

.table-footer {
  padding: 12px 16px;
  background: var(--bs-tertiary-bg);
}

.btn-exit-all {
  padding: 10px 20px;
  background: #EF0107;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}

.btn-exit-all:hover {
  background: #c70000;
}

/* Mobile Cards */
.mobile-container {
  padding: 0;
}

.position-card {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.position-card.faded {
  opacity: 0.5;
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.card-header-row .header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-header-row .instrument-name {
  font-weight: 600;
  font-size: 15px;
  color: var(--bs-body-color);
}

.card-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 12px 0;
  border-top: 1px solid var(--bs-border-color);
  border-bottom: 1px solid var(--bs-border-color);
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.detail-label {
  font-size: 11px;
  color: var(--bs-secondary-color);
}

.detail-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--bs-body-color);
}

.detail-value.positive {
  color: #0BDA51;
}

.detail-value.negative {
  color: #EF0107;
}

.card-footer-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.change-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
}

.change-badge.positive {
  background: rgba(11, 218, 81, 0.1);
  color: #0BDA51;
}

.change-badge.negative {
  background: rgba(239, 1, 7, 0.1);
  color: #EF0107;
}

.card-actions {
  display: flex;
  gap: 8px;
}

.btn-card {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-card.exit {
  background: rgba(239, 1, 7, 0.1);
  color: #EF0107;
}

.btn-card.add {
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.btn-exit-mobile {
  width: 100%;
  padding: 14px;
  background: #EF0107;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

/* Modal styling */
.modal-content {
  background-color: var(--bs-body-bg);
  border: none;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  border-bottom: 1px solid var(--bs-border-color);
  padding: 20px 24px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
}

.modal-body {
  padding: 24px;
}

.modal-subtitle {
  font-size: 14px;
  color: var(--bs-secondary-color);
  margin-bottom: 16px;
}

.exit-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.exit-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: var(--bs-tertiary-bg);
  border-radius: 8px;
}

.exit-item i {
  color: #EF0107;
}

.exit-item span {
  flex: 1;
  font-weight: 500;
}

.mkt-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
}

.modal-footer {
  border-top: 1px solid var(--bs-border-color);
  padding: 16px 24px;
  gap: 10px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .page-container {
    padding: 15px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .header-left {
    justify-content: space-between;
  }

  .total-pl-badge {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/position/Position.vue